export const API_URL = 'https://api.seakr.co.uk';
// export const API_URL = 'http://localhost:3030';

export const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const EXCEL_EXTENSION = '.xlsx';
